import { EkgIcon } from '@ui/kit';
import { itemCls, headerCls, iconCls, labelCls, messageCls, linkCls, buttonCls, backgroundIconCls } from './Item.style.js';
import { ITEM_TRANSITION_DELAY_MS } from './Snackbar.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function SnackbarItem({
  notification,
  index,
  closeNotification,
  ref
}) {
  const enterDelay = `${ITEM_TRANSITION_DELAY_MS * index}ms`;
  const onClose = () => {
    closeNotification(notification);
  };
  return /*#__PURE__*/jsxs("section", {
    ref: ref,
    className: itemCls,
    style: {
      transitionDelay: enterDelay
    },
    role: "status",
    "aria-live": "polite",
    children: [/*#__PURE__*/jsxs("header", {
      className: headerCls,
      children: [/*#__PURE__*/jsx("span", {
        className: iconCls,
        children: /*#__PURE__*/jsx(EkgIcon, {
          height: 13
        })
      }), /*#__PURE__*/jsx("h4", {
        className: labelCls,
        children: "Driftsnotifikation"
      })]
    }), /*#__PURE__*/jsx("div", {
      className: messageCls,
      children: notification.title
    }), /*#__PURE__*/jsxs("div", {
      children: [/*#__PURE__*/jsx("a", {
        className: linkCls,
        href: notification.url,
        target: "_blank",
        rel: "noreferrer",
        children: "L\xE6s mere"
      }), /*#__PURE__*/jsx("button", {
        className: buttonCls,
        onClick: onClose,
        children: "Luk"
      })]
    }), /*#__PURE__*/jsx("span", {
      role: "presentation",
      className: backgroundIconCls,
      children: /*#__PURE__*/jsx(EkgIcon, {
        height: 80,
        strokeWidth: "0.8"
      })
    })]
  });
}

export { SnackbarItem };
//# sourceMappingURL=Item.js.map
